<template>
    <div>
        <div v-for="milestone in milestones">
            <project-milestone
                :project="project"
                :milestone="milestone"
                @milestonesChanged="refreshMilestones"
            />
        </div>

        <!--Add new -->
        <div class="card">
            <div class="flex items-center">
                <div class="flex items-center">
                    <span class="icon-circle bg-neutral-lightest">
                        <font-awesome-icon icon="flag-checkered" />
                    </span>
                    <span class="ml-md text-sm font-semibold">Lägg till delmål</span>
                </div>
                <div class="ml-auto">
                    <button class="btn-icon is-primary" @click="$modal.show('add-edit-milestone')">
                        <font-awesome-icon icon="plus" size="xs" />
                    </button>
                </div>
            </div>
        </div>

        <add-edit-milestone-modal :project="project" @milestonesChanged="refreshMilestones" />
    </div>
</template>

<script>
    import AddEditMilestoneModal from './AddEditMilestoneModal.vue';
    import ProjectMilestone from './ProjectMilestone.vue';

    export default {
        components: {
            AddEditMilestoneModal,
            ProjectMilestone,
        },

        props: {
            project: {
                required: true,
                type: Object,
            },

            initialMilestones: {
                required: true,
                type: Array,
            },
        },

        data() {
            return {
                milestones: this.initialMilestones,
            };
        },

        methods: {
            refreshMilestones(newMilesStones) {
                this.milestones = newMilesStones;
            },
        },
    };
</script>
